import { EstateOwner } from "@1games-ru/region-shared/dist/enums/estate/estate";
import { useTranslation } from "react-i18next";
import { House2Icon } from "@/shared/icons";
import PersonalDataCard from "@/shared/widgets/PersonalDataCard";
import { Owner } from "@/domains/estate/slice.ts";

function EstateOwnerInfo({ owner }: { owner: Owner }) {
  const { t } = useTranslation("estate");

  if (!owner) {
    return (
      <div className="flex items-center gap-2.5">
        <House2Icon size={20} className="text-[#84FF97]" />
        <div className="text-14 text-[#84FF97] font-bold uppercase">{t("estate.forSale")}</div>
      </div>
    );
  }

  if (owner.type === EstateOwner.Character) {
    return (
      <PersonalDataCard
        id={owner.content.characterId}
        name={owner.content.name}
        isOnline={!!owner.content.playerMpId}
      />
    );
  }

  return <div>Я ЛЮБЛЮ ФРОНТЕНД! Я ГОМОСЕК!</div>;
}

export default EstateOwnerInfo;
